// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"eb27559f","174":"caba173a","279":"d6d51b9f","488":"c24af942","592":"0c3fc4c2","610":"6ca9f366","708":"3286e399","714":"f9c1ae14","811":"68097119","837":"9f3c20ee"}[chunkId] + ".chunk.js";
};